import api from './api';

// Use the main API instance which has CSRF token handling built-in

/**
 * @desc    Get user's wishlist
 * @route   GET /api/users/wishlist
 */
export const getWishlist = async () => {
  try {
    const response = await api.get('/api/users/wishlist');
    return response.data;
  } catch (error) {
    throw error.response?.data?.error || error.message || 'Failed to fetch wishlist';
  }
};

/**
 * @desc    Add product to wishlist
 * @route   POST /api/users/wishlist
 */
export const addToWishlist = async (productId) => {
  try {
    const response = await api.post('/api/users/wishlist', { productId });
    return response.data;
  } catch (error) {
    // Handle CSRF errors gracefully
    if (error.response?.status === 403 && error.response?.data?.error?.includes('CSRF')) {
      throw new Error('Please refresh the page and try again');
    }
    throw error.response?.data?.error || error.message || 'Failed to add to wishlist';
  }
};

/**
 * @desc    Remove product from wishlist
 * @route   DELETE /api/users/wishlist/:productId
 */
export const removeFromWishlist = async (productId) => {
  try {
    const response = await api.delete(`/api/users/wishlist/${productId}`);
    return response.data;
  } catch (error) {
    // Handle CSRF errors gracefully
    if (error.response?.status === 403 && error.response?.data?.error?.includes('CSRF')) {
      throw new Error('Please refresh the page and try again');
    }
    throw error.response?.data?.error || error.message || 'Failed to remove from wishlist';
  }
};
